import { Component } from "../component"

export class SocialPopup extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return { socialLinkPopup: ".social-link-popup" }
  }

  initShareLinks() {
    const { socialLinkPopup } = this.ui()

    const shareLinks = document.querySelectorAll(socialLinkPopup)

    shareLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault()
        const title = e.target.getAttribute("data-title") || ""
        this.windowPopup(e.target.href, title, 500, 300)
      })
    })
  }

  windowPopup(url, title, width, height) {
    const left = window.screenLeft + window.outerWidth / 2 - width / 2
    const top = window.screenTop + window.outerHeight / 2 - height / 2

    window.open(
      url,
      title,
      `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`
    )
  }

  created() {
    this.initShareLinks()
  }
}
